import { isDev } from '@/utils/common';

import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const Report: AppRouteRecordRaw = {
  path: '/report',
  name: 'Report',
  component: DEFAULT_LAYOUT,
  meta: {
    title: '报表分析',
    requiresAuth: true,
    icon: 'icon-bar-chart',
    order: 6,
  },
  children: [
    {
      path: 'allprocess-detail-report',
      name: 'AllprocessDetailReport',
      component: () =>
        import('@/views/report/allprocessDetailReport/index.vue'),
      meta: {
        title: '生产明细',
        requiresAuth: true,
        roles: ['completeFlowReportGet'],
      },
    },
    {
      path: 'production-report',
      name: 'ProductionReport',
      component: () => import('@/views/report/production/index.vue'),
      meta: {
        title: '生产报表',
        requiresAuth: true,
        roles: ['produceStatisticsGet'],
      },
    },
    {
      path: 'produce-cost-report',
      name: 'ProduceCostReport',
      component: () => import('@/views/report/produceCostReport/index.vue'),
      meta: {
        title: '生产成本报表',
        requiresAuth: true,
        roles: ['goodsCostPriceReportGet'],
      },
    },
    {
      path: 'same-colorcode-summary',
      name: 'SameColorCodeSummary',
      component: () => import('@/views/report/sameColorCodeSummary/index.vue'),
      meta: {
        title: '同款色码汇总',
        requiresAuth: true,
        roles: ['colorSizeStatisticsGet'],
      },
    },
    {
      path: 'finished-in-report',
      name: 'FinishedInReport',
      component: () => import('@/views/report/finished-in-report/index.vue'),
      meta: {
        title: '成品入库报表',
        requiresAuth: true,
        roles: ['goodsStoreInStaticsGet'],
      },
    },
    {
      path: 'out-days-reprot',
      name: 'OutDaysReport',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '出货分析报表',
        requiresAuth: true,
        roles: ['produceOutStatisticsGet'],
        amisAppId: isDev() ? '21352737' : '05fd89e3',
      },
    },
    {
      path: 'production-monitoring-screen',
      name: 'ProductionMonitoringScreen',
      component: () =>
        import('@/views/production/productionMonitoringScreen/index.vue'),
      meta: {
        title: '生产监控大屏',
        requiresAuth: true,
        roles: ['produceMonitorScreenGet'],
      },
    },
    {
      path: 'edition-workprocess-report',
      name: 'EditionWorkprocessReport',
      component: () =>
        import('@/views/report/editionWorkprocessReport/index.vue'),
      meta: {
        title: '版单工序报表',
        requiresAuth: true,
        roles: ['designNodeReportStatisticsGet'],
        flagShip: true,
      },
    },
    {
      path: 'outsource-report',
      name: 'OutsourceReport',
      component: () => import('@/views/report/outsourceReport/index.vue'),
      meta: {
        title: '外发回收报表',
        requiresAuth: true,
        roles: ['outWardStaticsGet'],
      },
    },
    {
      path: 'production-workprocess-report',
      name: 'ProductionWorkprocessReport',
      component: () =>
        import('@/views/report/productionWorkprocessReport/index.vue'),
      meta: {
        title: '生产工序报表',
        requiresAuth: true,
        roles: ['produceWorkProcessReportStatisticsGet'],
      },
    },
    {
      path: 'material-transfer-report',
      name: 'MaterialTransferReport',
      component: () =>
        import('@/views/material/materialTransferReport/index.vue'),
      meta: {
        title: '物料调拨报表',
        requiresAuth: true,
        roles: ['materialTransferStatisticsGet'],
      },
    },
    {
      path: 'purchase-report',
      name: 'PurchaseReport',
      component: () => import('@/views/production/purchaseReport/index.vue'),
      meta: {
        title: '生产采购报表',
        requiresAuth: true,
        roles: ['purchaseProcessStatistics', 'purchaseProcessStatisticsGet'],
      },
    },
    {
      path: 'material-purchase-report',
      name: 'MaterialPurchaseReport',
      component: () =>
        import('@/views/report/materialPurchaseReport/index.vue'),
      meta: {
        title: '物料采购报表',
        requiresAuth: true,
        roles: ['materialPurchaseStatisticsGet'],
      },
    },
    {
      path: 'material-picking-report',
      name: 'MaterialPickingReport',
      component: () => import('@/views/report/materialPickingReport/index.vue'),
      meta: {
        title: '物料领料报表',
        requiresAuth: true,
        roles: ['materialPickReportGet'],
      },
    },
    {
      path: 'material-in-report',
      name: 'MaterialInReport',
      component: () => import('@/views/report/material-in-report/index.vue'),
      meta: {
        title: '物料入库报表',
        requiresAuth: true,
        roles: ['materialStoreInReportGet'],
      },
    },
    {
      path: 'material-out-report',
      name: 'MaterialOutReport',
      component: () => import('@/views/report/material-out-report/index.vue'),
      meta: {
        title: '物料出库报表',
        requiresAuth: true,
        roles: ['materialStoreOutReportGet'],
      },
    },
    {
      path: 'finance-report',
      name: 'FinanceReport',
      component: () => import('@/views/report/financeReport/index.vue'),
      meta: {
        title: '财务报表',
        requiresAuth: true,
        hideInMenu: true,
        roles: ['*'],
      },
    },
    {
      path: 'ticket-report',
      name: 'TicketReport',
      component: () => import('@/views/report/ticketReport/index.vue'),
      meta: {
        title: '菲票统计',
        requiresAuth: true,
        roles: ['scanTicketStatisticsGet'],
      },
    },
    {
      path: 'inspection-statistics',
      name: 'InspectionStatistics',
      component: () => import('@/views/report/inspectionStatistics/index.vue'),
      meta: {
        title: '质检统计',
        requiresAuth: true,
        roles: ['inspectionStatisticsGet'],
      },
    },
    {
      path: 'paper-sample-statistics',
      name: 'PaperSampleStatistics',
      component: () => import('@/views/report/paperSampleStatistics/index.vue'),
      meta: {
        title: '纸样统计',
        requiresAuth: true,
        roles: ['statisticsPaperGet'],
      },
    },
  ],
};

export default Report;
